import { useEffect, useState, createContext, useContext } from "react";
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const BrandingContext = createContext({ logo_data_url: null, brand_name: "Caring", brand_tagline: "Estimativas", reload: () => {} });

export function useBranding() { return useContext(BrandingContext); }

export function BrandingProvider({ children }) {
  const [b, setB] = useState({ logo_data_url: null, brand_name: "Caring", brand_tagline: "Estimativas" });
  const load = () => axios.get(`${BACKEND_URL}/api/branding`).then((r) => setB(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);
  return <BrandingContext.Provider value={{ ...b, reload: load }}>{children}</BrandingContext.Provider>;
}

export function BrandMark({ size = 36, showText = true, className = "", theme = "light" }) {
  const { logo_data_url, brand_name, brand_tagline } = useBranding();
  const isDark = theme === "dark";
  return (
    <div className={`flex items-center gap-2.5 ${className}`}>
      {logo_data_url ? (
        <img src={logo_data_url} alt={brand_name} style={{ width: size, height: size }} className={`rounded-lg object-contain ${isDark ? "bg-white/10" : "bg-[#F1F5F9]"}`} />
      ) : (
        <div style={{ width: size, height: size }} className="rounded-lg bg-gradient-to-br from-[#3B82F6] to-[#059669] flex items-center justify-center">
          <svg width={size*0.55} height={size*0.55} viewBox="0 0 24 24" fill="none" stroke="#0F172A" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg>
        </div>
      )}
      {showText && (
        <div>
          <div className={`font-display text-lg leading-none ${isDark ? "text-white" : ""}`}>{brand_name}</div>
          <div className={`text-[10px] uppercase tracking-[0.2em] mt-1 ${isDark ? "text-white/60" : "text-muted-foreground"}`}>{brand_tagline}</div>
        </div>
      )}
    </div>
  );
}
